import * as yup from 'yup';
import { sharedElpaFields } from '@/views/checkouts/companies/Elpa/shared/sharedElpaSchema';

export const CarElpaSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    return yup.object({
        ...sharedElpaFields(
            firstDriverAdditionalPremiumAge,
            secondDriverAdditionalPremiumAge,
            firstDriverAdditionalPremiumLicenseYears,
            secondDriverAdditionalPremiumLicenseYears,
            legalEntity,
            secondDriver,
            discountEntity,
            vehicleType
        ),
    });
};

export default CarElpaSchemaBuilder;
